import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import useIsMobile from "../../hooks/device/useIsMobile";
import { checkBrandUserAgent } from "../components/MobileAppBanner/utils/check-brand-user-agent";
import { checkSafariUserAgent } from "../components/MobileAppBanner/utils/check-safari-user-agent";
import { isAllowedRoute } from "../components/MobileAppBanner/utils/is-allowed-route";
import { useMobileAppBannerStore } from "./useMobileAppBannerStore";

function useMobileAppBannerVisibility(): boolean {
  const isMobile = useIsMobile();
  const location = useLocation();
  const { isVisible } = useMobileAppBannerStore();
  const hasBonusxUserAgent = checkBrandUserAgent();
  const hasSafariUserAgent = checkSafariUserAgent();
  const shouldBeVisibleBasedOnRoute = isAllowedRoute(location.pathname);

  const isBannerVisible = useMemo(
    function memoizeBannerVisibility() {
      return isMobile && shouldBeVisibleBasedOnRoute && isVisible && !hasBonusxUserAgent && !hasSafariUserAgent;
    },
    [isMobile, shouldBeVisibleBasedOnRoute, isVisible, hasBonusxUserAgent, hasSafariUserAgent]
  );

  return isBannerVisible;
}

export default useMobileAppBannerVisibility;
